<template>
  <div class="ExcellentCase">
    <SeachFilter
      @changeQuery="currentQuery"
      :queryParams="queryParams"
      :exportLoading="exportLoading"
      @exportQuery="tableExport"
      @importExcel="importExcelRef.showConfirm()"
    />
    <a-table
      class="tableContainer"
      :columns="excellentCaseColumns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="excellentCaseId"
      :scroll="{ x: '100%', y: 'calc(100vh - 400px)' }"
      :loading="tableLoading"
    >
      <template #workOrderId="{ record, text: workOrderId }">
        <span class="numLink" @click="viewDetails(record)">
          {{ workOrderId }}
        </span>
      </template>
      <template #auditStatus="{ record, text: auditStatus }">
        <a-tag :color="['green', 'cyan', 'blue', 'purple'][auditStatus]">
          {{ record.auditStatusValue }}
        </a-tag>
      </template>
      <template #handle="{ record }">
        <a-button type="link" @click="caseDetailRef.showCaseDetail(record)">查看详情</a-button>
        <a-button type="link" danger @click="deleteCase(record)">删除</a-button>
      </template>
    </a-table>
    <a-row type="flex" justify="start" style="margin: 20px 0 0 20px">
      <a-col>
        <a-pagination
          v-if="Total"
          show-size-changer
          show-quick-jumper
          v-model:current="current"
          v-model:pageSize="pageSize"
          :total="Total"
          @change="listQuery"
          @showSizeChange="listQuery"
          :show-total="Total => `共${Total}条`"
        />
      </a-col>
    </a-row>
    <ImportExcel ref="importExcelRef" @refresh="listQuery" />
    <CaseDetail ref="caseDetailRef" />
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
  </div>
</template>

<script setup>
import SeachFilter from './seachFilter.vue'
import { ref, createVNode, onMounted, computed } from 'vue'
import useTableTools from '@/views/hooks/useTableTools'
import ImportExcel from './importExcel.vue'
import CaseDetail from './caseDetail'
import { excellentCaseColumns } from '@/constants/columns/index'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import { ExcellentCaseList, ExcellentCaseDelete } from '@/api/ExcellentCase/index'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'
import moment from 'moment'

const { normalizeExport, Total, current, pageSize, TableData } = useTableTools()
const tableLoading = ref(false)
const store = useStore()
const initDate = [
  moment().subtract(1, 'months').format('YYYY-MM-DD 00:00:00'),
  moment().format('YYYY-MM-DD 23:59:59')
]
const defaultQuery = {
  workOrderIds: null,
  daName: null,
  createdAtMin: initDate[0],
  createdAtMax: initDate[1],
  auditTimeMin: null,
  auditTimeMax: null,
  workOrderTypes: null,
  dptName: null,
  branchCompanyName: null,
  majorAreaName: null
}
const { queryParams, initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.EXCELLENT_CASE_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  normalize: params => ({
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params)
  })
})
const importExcelRef = ref(null)
const caseDetailRef = ref(null)

const currentQuery = params => {
  tableLoading.value = true
  current.value = 1
  updateCache(params)
  listQuery()
}

const exportLoading = ref(false)
const tableExport = async params => {
  exportLoading.value = true
  await normalizeExport(
    '/health-doctor-assistant/workOrderExcellentCase/export',
    {
      ...params,
      workOrderIds: params.workOrderIds ? [params.workOrderIds] : [],
      workOrderTypes: params.workOrderTypes ? [params.workOrderTypes] : [],
      whetherSelectPower: false
    },
    '优秀案例',
    'post'
  )
  exportLoading.value = false
}

const listQuery = () => {
  ExcellentCaseList({
    ...queryParams.value,
    whetherSelectPower: false,
    workOrderIds: queryParams.value.workOrderIds ? [queryParams.value.workOrderIds] : [],
    workOrderTypes: queryParams.value.workOrderTypes ? [queryParams.value.workOrderTypes] : [],
    pageNo: current.value,
    pageSize: pageSize.value
  })
    .then(res => {
      TableData.value = res.list
      Total.value = res.totalCount
    })
    .finally(() => {
      tableLoading.value = false
    })
}

const deleteCase = ctxRecord => {
  Modal.confirm({
    title: () => '确定删除该优秀案例吗?',
    content: '是否确定删除，删除后无法恢复',
    icon: () => createVNode(DeleteOutlined),
    okText: () => '确认',
    okType: 'danger',
    cancelText: () => '取消',
    okButtonProps: {
      type: 'primary',
      style: {
        background: '#FF4848'
      }
    },
    onOk() {
      ExcellentCaseDelete({
        excellentCaseId: ctxRecord.excellentCaseId
      }).then(() => {
        message.success('删除成功！')
        listQuery()
      })
    }
  })
}

const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}

const showAllDialog = ref(false)
const currentInfo = ref({})
const info = ref({})
const viewDetails = data => {
  const { workOrderType } = data
  showAllDialog.value = true
  currentInfo.value = { ...data, businessType: workOrderType }
  info.value = { ...data, businessType: workOrderType }
}

onMounted(() => {
  initFromCache()
  listQuery()
})
</script>

<style lang="scss" scoped>
.ExcellentCase {
  height: 100%;
}
.ExcellentCase .tableContainer {
  padding: 10px 20px 0;

  .numLink {
    cursor: pointer;
    color: #1890ff;
  }
}
</style>
